export default __webpack_public_path__ + "static/media/480_dummy2016-naeherin01-mobile-de.3cb9934e.png";